import {
  savePersonInfo,
  saveStudyInfo,
  saveApplyInfo as saveApplySci,
} from '@assets/apis/scientist';
import {
  saveAdditionInfo,
  saveBaseInfo,
  saveApplyInfo as saveApplyInno,
} from '@assets/apis/innovate';
import { getSimpleContext } from '../_utils/simple';
import { getFormType } from '../_utils';

export const { Provider, useSimpleContext } = getSimpleContext({
  disabled: false,
  // 表单进度
  step: 1,
  saving: false,
  // scientist青山科技奖 innovate环保创新
  formType: getFormType(),
  loading: true,
  hasChange: false,
  innovate: {
    apiSaves: [saveBaseInfo, saveAdditionInfo, saveApplyInno],
    // 申报方向
    projectDict: [],
    iniValues: { baseInfo: {}, additionInfo: {}, applyInfo: {} },
  },
  scientist: {
    apiSaves: [savePersonInfo, saveStudyInfo, saveApplySci],
    iniValues: { personInfo: {}, studyInfo: {}, applyInfo: {} },
    // 科研议题
    topics: [],
    //学科领域 专一领域
    subjects: [],
    //学科领域 交叉领域
    subjects2: [],
  },
  // 保存接口
  handleSave: () => new Promise((resolve) => resolve()), //

  // 验证接口
  validateFields: () => {
    //
  },
  values: {},
  // 是否审核模式
  isViewType: false,
  // 审核项目no
  projectNo: '',
  // 表单是否已提交。有一个提交后，两个表单都禁用
  hasSubmit: false,
  // 打开提交完成的弹窗
  onSubmit: false,
  hasSave: true,
  submitType: '',
  // 上传参数
  token: {
    awsaccessKeyId: '',
    host: '',
    bucketName: '',
    policy: '',
    signature: '',
    dir: '',
  },
  tempUrl: '',

});
